let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b9TzU")).then(() => parcelRequire('enPQi'));